'use client';

import * as React from 'react';
import {
  CalculatorIcon,
  FileCheckIcon,
  RefreshCcwIcon,
  Wand2Icon
} from 'lucide-react';
import { motion } from 'motion/react';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@workspace/ui/components/card';
import {
  Autoplay,
  Carousel,
  CarouselContent,
  CarouselItem
} from '@workspace/ui/components/carousel';
import { cn } from '@workspace/ui/lib/utils';

const DATA = [
  {
    icon: FileCheckIcon,
    title: 'Rechnung erkannt (SKR03)',
    timing: 'Automatisch zugeordnet'
  },
  {
    icon: RefreshCcwIcon,
    title: 'Reverse Charge angewendet',
    timing: 'Steuerschuldnerschaft berücksichtigt'
  },
  {
    icon: CalculatorIcon,
    title: 'Währungsumrechnung ($ -> €)',
    timing: 'Tagesaktueller EZB-Kurs'
  },
  {
    icon: Wand2Icon,
    title: 'Auto-Vorkontierung',
    timing: 'Buchungssatz erstellt'
  }
];

const MotionCard = motion.create(Card);

export function BentoAutomationCard({
  className,
  ...other
}: React.ComponentPropsWithoutRef<typeof MotionCard>): React.JSX.Element {
  return (
    <MotionCard
      className={cn(
        'relative h-[300px] max-h-[300px] overflow-hidden',
        className
      )}
      {...other}
    >
      <CardHeader>
        <CardTitle className="text-xl font-semibold">
          Automatisierung
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-4 line-clamp-2 text-sm text-muted-foreground">
          Ihre Buchhaltung läuft im Hintergrund. Jeder Schritt wird automatisch dokumentiert.
        </p>
        <Carousel
          opts={{
            align: 'start',
            skipSnaps: true,
            loop: true,
            dragFree: true
          }}
          plugins={[
            Autoplay({
              delay: 2000
            })
          ]}
          orientation="vertical"
          className="pointer-events-none size-full select-none"
        >
          <CarouselContent className="pointer-events-none -mt-1 h-[232px] select-none sm:h-[146px]">
            {DATA.map(({ title, timing, icon: Icon }, index) => (
              <CarouselItem
                key={index}
                className="pointer-events-none basis-1/4 select-none pt-1 will-change-transform"
              >
                <Card className="m-1 p-0">
                  <CardContent className="flex w-full flex-row items-center justify-start gap-3 p-4 sm:gap-4 sm:p-6">
                    <div className="shrink-0 rounded-full bg-primary p-2 text-primary-foreground">
                      <Icon className="size-4 shrink-0 sm:size-5" />
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="truncate text-xs font-medium sm:text-sm">
                        {title}
                      </div>
                      <div className="truncate text-[10px] text-muted-foreground sm:text-xs">
                        {timing}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </CardContent>
    </MotionCard>
  );
}

